import { EntityMetadataMap } from '@ngrx/data';
import { PartnerModel } from '../../modules/partner/common/api/model/partner.model';
import { OfficeModel } from '../../modules/office/api/model/office.model';
import { DocumentModel } from '../../modules/document/common/api/model/document.model';
import { PartnerNote } from '../../modules/partner/modules/note/api/entity/partnerNote.model';
import { User } from '../../modules/account/modules/user/api/entity/user.model';
import { AgendaCategory } from '../../modules/agenda/modules/category/api/entity/agendaCategory.model';
import { AgendaEventModel } from '../../modules/agenda/modules/event/api/entity/agendaEvent.model';
import { AgendaCalendarModel } from '../../modules/agenda/modules/calendar/api/entity/agendaCalendar.model';
import { PartnerPersonModel } from '../../modules/partner/modules/person/api/entity/partnerPerson.model';
import { Practitioner } from '../../shared/model/practitioner/practitioner.model';
import { MedicalRecordGeneralInformationModel } from '../../modules/medical/medical-record/general-information/api/model/medicalRecordGeneralInformation.model';
import { LovValue } from '../../modules/common/lov/lov-value/api/model/LovValue.model';
import {
    MedicalRecordPractitionerModel } from '../../modules/medical/medical-record/practitioner/api/model/medicalRecordPractitioner.model';
import { MedicalRecordSportModel } from '../../modules/medical/medical-record/sport/api/model/medicalRecordSport.model';
import { PersonModel } from '../../modules/person/api/entity/person.model';
import { PartnerContactModel } from '../../modules/partner/modules/contact/api/model/partnerContact.model';
import { MedicalRecordPainModel } from '../../modules/medical/medical-record/pain/api/model/medicalRecordPain.model';
import { StatisticModel } from '../../modules/common/statistic/api/entity/statistic.model';
import { MedicalRecordVisitReasonModel } from '../../modules/medical/medical-record/visit-reason/api/model/medicalRecordVisitReason.model';
import { LovListModel } from '../../modules/common/lov/lov-list/api/model/lovList.model';
import { MedicalRecordProblemModel } from '../../modules/medical/medical-record/problem/api/model/medicalRecordProblem.model';
import { ProductModel } from '../../modules/product/api/entity/product.model';
import { SaleModel } from '../../modules/sale/api/entity/sale.model';
import { SaleInvoiceModel } from '../../modules/sale/modules/invoice/api/entity/saleInvoice.model';
import { EntityLogModel } from '../../modules/common/log/api/entity/entityLog.model';
import { PaymentRequestModel } from '../../modules/sale/modules/payment_request/api/entity/paymentRequest.model';
import { SaleProductModel } from '../../modules/sale/modules/product/api/entity/saleProduct.model';
import { CountryModel } from '../../modules/common/localization/country/api/entity/country.model';
import { ProductDeliveredModel } from '../../modules/product/delivered/api/entity/productDelivered.model';
import { PurchaseOrderModel } from '../../modules/sale/modules/purchase_order/api/entity/purchaseOrder.model';
import { SaleInvoiceConfigurationModel } from '../../modules/sale/modules/invoice/modules/configuration/api/entity/saleInvoiceConfiguration.model';
import { FormDefinitionFormModel } from '../../modules/form/definition/form/api/entity/formDefinitionForm.model';
import { FormDefinitionFieldModel } from '../../modules/form/definition/field/api/entity/formDefinitionField.model';
import { ExamenDefinitionModel } from '../../modules/examen/definition/api/entity/examenDefinition.model';
import { ChargedActModel } from '../../modules/medical/charged-act/api/entity/chargedAct.model';
import { ReportComponentDefinitionModel } from '../../modules/reporting/report-component-definition/api/entity/reportComponentDefinition.model';
import { ReportComponentModel } from '../../modules/reporting/report-component/api/entity/reportComponent.model';
import { OnlineFormFormDefinitionModel } from '../../modules/online-form/definition/api/entity/onlineFormFormDefinition.model';
import { OnlineFormModel } from '../../modules/online-form/form/api/entity/onlineForm.model';
import { ExamFormModel } from '../../modules/exam-form/api/model/exam-form.model';
import { PaymentRequestConfigurationModel } from '../../modules/sale/modules/payment_request/configuration/api/entity/paymentRequestConfiguration.model';
import { PaymentRequestReminderModel } from '../../modules/sale/modules/payment_request/reminder/api/entity/paymentRequestReminder.model';
import { WorkflowTaskModel } from '../../modules/workflow/task/api/model/common/workflowTask.model';
import { DiscussionModel } from '../../modules/discussion/modules/common/api/model/discussion.model';
import { MessageModel } from '../../modules/message/api/model/messageModel';
import { SubscriptionModel } from '../../modules/subscription/api/entity/subscription.model';
import { SupportModel } from '../../modules/support/api/model/support.model';
import {
    NewsletterPartnerConfigModel
} from '../../modules/newsletter/partner/config/api/entity/NewsletterPartnerConfig.model';
import {
    WorkflowTaskDefinitionModel
} from '../../modules/workflow/task/definition/api/model/workflowTaskDefinition.model';
import {
    CommunicationContentModelModel
} from '../../modules/communication/content-model/api/entity/communicationContentModel.model';
import { MedicalReportModel } from '../../modules/medical/report/api/entity/medicalReport.model';
import { ReportDefinitionModel } from '../../modules/reporting/report-definition/api/entity/reportDefinition.model';
import {
    ReportAccountComponentModel
} from '../../modules/reporting/report-account-component/api/entity/reportAccountComponent.model';
import {
    CommunicationContentSubstitutionModel
} from '../../modules/communication/content-substitution/api/model/communicationContentSubstitution.model';
import { Scanner3dModel } from '../../modules/insole/scanner3d/common/api/entity/scanner3d.model';
import { Scanner3dAccountModel } from '../../modules/insole/scanner3d/account/api/entity/scanner3dAccount.model';
import { Scan3dGroupModel } from '../../modules/insole/scan3d/scanGroup/api/entity/scan3dGroup.model';
import { Scan3dModel } from '../../modules/insole/scan3d/common/api/entity/scan3d.model';
import { ProductRetrocessionModel } from '../../modules/product/retrocession/api/entity/productRetrocession.model';
import {
    AgendaReminderConfigurationModel
} from '../../modules/agenda/modules/reminder/configuration/api/entity/agendaReminderConfiguration.model';
import {
    TreatmentDefinitionModel
} from '../../modules/medical/treatment/treatment-definition/api/entity/treatmentDefinitionModel';
import { TreatmentModel } from '../../modules/medical/treatment/common/api/model/treatment.model';
import {SaleRetrocessionModel} from '../../modules/sale/modules/retrocession/api/entity/saleRetrocession.model';
import {InsolesModel} from '../../modules/insole/insoles/api/model/insoles.model';
import {
    ConsultationCategoryModel
} from '../../modules/medical/consultation/category/api/model/consultationCategory.model';
import {ConsultationModel} from '../../modules/medical/consultation/consultation/api/model/consultation.model';
import {
    PrescriptionMedicineModel
} from '../../modules/medical/prescription/medicine/api/model/prescriptionMedicine.model';
import {BankCheckModel} from '../../modules/accounting/bank-check/api/model/bankCheck.model';
import {PrescriptionModel} from '../../modules/medical/prescription/prescription/api/model/prescription.model';
import { TimeLogModel } from 'src/app/modules/time-management/time-log/api/model/timeLog.model';
import {
    TreatmentFeedbackModel
} from '../../modules/medical/treatment/treatment-feedback/api/models/treatment-feedback.model';
import {WebshopProductModel} from '../../modules/webshop/product/api/model/webshopProduct.model';
import {WebshopCartModel} from '../../modules/webshop/cart/api/models/webshop-cart.model';
import {WebshopCategoryModel} from '../../modules/webshop/category/api/models/webshopCategory.model';
import {MedicalMorphologyModel} from '../../modules/medical/morphology/api/model/medicalMorphology.model';
import {DiagnosticModel} from '../../modules/medical/diagnostic/api/model/diagnostic.model';
import {AgendaPeriodModel} from '../../modules/agenda/modules/period/api/model/agendaPeriod.model';
import {AgendaSlotModel} from '../../modules/agenda/modules/slot/api/model/agendaSlot.model';
import {CommunicationReportModel} from '../../modules/communication/report/api/model/communicationReport.model';
import {DiagnosticRuleGroupModel} from '../../modules/medical/diagnostic/ruleGroup/api/model/diagnosticRuleGroup.model';
import {PageViewedModel} from '../../modules/metrics/page-viewed/api/model/pageViewed.model';
import {AgendaBlockedPartnerModel} from '../../modules/agenda/modules/blacklist/api/model/AgendaBlockedPartner.model';
import {VisualIdentityModel} from '../../modules/communication/visual-identity/api/model/visualIdentity.model';
import {ParcelModel} from '../../modules/parcel/api/model/parcel.model';
import {EmailThemeModel} from '../../modules/communication/email-theme/api/model/emailTheme.model';
import {EmailThemeDefinitionModel} from '../../modules/communication/email-theme-definition/api/model/emailThemeDefinition.model';
import {ReportThemeModel} from '../../modules/communication/report-theme/api/model/reportTheme.model';
import {ReportThemeDefinitionModel} from '../../modules/communication/report-theme-definition/api/model/reportThemeDefinition.model';
import {AgendaWaitingListItemModel} from '../../modules/agenda/modules/waiting-list-item/api/model/AgendaWaitingListItem.model';
import {AgendaProfileModel} from '../../modules/agenda/modules/profile/api/model/AgendaProfile.model';
import {AccountingMovementModel} from '../../modules/accounting/movement/api/entity/accountingMovement.model';
import {AccountingAccountModel} from '../../modules/accounting/account/api/entity/accountingAccount.model';
import {AudioRecordModel} from '../../modules/common/audio/record/api/model/audioRecord.model';
import {
    NotificationDefinitionModel
} from '../../modules/notification/definition/common/api/model/notificationDefinition.model';
import {
    NotificationDefinitionGroupModel
} from '../../modules/notification/definition/group/api/model/notificationDefinitionGroup.model';
import {NotificationSettingModel} from '../../modules/notification/setting/api/model/notificationSetting.model';
import {NotificationModel} from '../../modules/notification/common/api/model/notification.model';
import {EmailMailboxModel} from '../../modules/communication/email/mailbox/api/entity/emailMailbox.model';
import {WebsiteThemeModel} from '../../modules/communication/website-theme/api/model/websiteTheme.model';
import {
    BusinessDataImportProcessModel
} from "../../modules/common/businessdataimport/api/entity/businessDataImportProcess.model";
import {
    InsoleElementDefinitionModel
} from "../../modules/insole/element/definition/api/model/insoleElementDefinition.model";
import {InsolesProviderModelModel} from "../../modules/insole/provider/model/api/entity/insolesProviderModel.model";
import {InsoleCadProcessModel} from "../../modules/insole/cad/api/model/insoleCadProcess.model";
import {TagModel} from "../../modules/common/tag/api/model/tag.model";
import {ProviderServiceModel} from "../../modules/provider/service/api/entity/providerService.model";
import {
    PaymentRequestMovementModel
} from "../../modules/sale/modules/payment_request/movement/api/entity/paymentRequestMovement.model";
import {InsolesProfileModel} from "../../modules/insole/profile/api/entity/insolesProfile.model";
import {AiDiscussionModel} from "../../modules/ai/discussion/api/model/aiDiscussion.model";
import {GoalDefinitionModel} from "../../modules/goal/definition/api/model/goalDefinition.model";
import {GoalModel} from "../../modules/goal/common/api/model/goal.model";
import {
    TreatmentJourneyDefinitionModel
} from "../../modules/medical/treatment/journey/definition/journey/api/entity/treatmentJourneyDefinition.model";
import {AudioTranscriptionModel} from "../../modules/common/audio/transcription/api/model/audioTranscription.model";
import {
    TreatmentJourneyModel
} from "../../modules/medical/treatment/journey/common/journey/api/entity/treatmentJourney.model";
import {InsolesModelModel} from "../../modules/insole/insolemodel/api/entity/insolesModel.model";
import {InsoleMaterialModel} from "../../modules/insole/material/api/entity/insoleMaterial.model";
import {
    OpenBankingRequisitionModel
} from "../../modules/accounting/openbanking/requisition/api/model/openBankingRequisition.model";
import {OpenBankingAccountModel} from "../../modules/accounting/openbanking/account/api/model/openBankingAccount.model";
import {
    OpenBankingTransactionModel
} from "../../modules/accounting/openbanking/transaction/api/model/openBankingTransaction.model";
import {ProviderCamMachineModel} from "../../modules/insole/provider/cammachine/api/entity/providerCamMachine.model";
import {
    CommunicationConfigurationEmailSenderModel
} from "../../modules/communication/configuration/email/sender/api/entity/communicationConfigurationEmailSender.model";
import {
    PrescriptionDefinitionModel
} from "../../modules/medical/prescription/definition/api/entity/prescriptionDefinition.model";
import {DeviceDefinitionModel} from "../../modules/medical/device/definition/api/entity/deviceDefinition.model";
import {MedicalDeviceModel} from "../../modules/medical/device/account/api/entity/medicalDevice.model";
import {MedicalToolSetModel} from "../../modules/medical/sterilization/toolset/api/entity/medicalToolSet.model";
import {
    MedicalSterilizationModel
} from "../../modules/medical/sterilization/sterilization/api/entity/medicalSterilization.model";
import {ProviderServiceOptionModel} from "../../modules/provider/service/option/api/entity/providerServiceOption.model";
import {PriceListModel} from "../../modules/subscription/pricelist/api/entity/priceList.model";
import {
    PaymentCardReaderModel
} from "../../modules/sale/modules/payment/paymentCardReader/api/entity/paymentCardReader.model";
import {
    PaymentRequestOnlineAttemptModel
} from "../../modules/sale/modules/payment_request/payment_request_online_attempt/api/entity/paymentRequestOnlineAttempt.model";
import {DocumentTemplateModel} from "../../modules/document/template/api/entity/documentTemplate.model";
import {ProductStockUnitModel} from "../../modules/product/stock/unit/api/entity/productStockUnit.model";
import {CamJobModel} from "../../modules/insole/cam/job/api/entity/camJob.model";

// @ts-ignore
export const entityMetadata: EntityMetadataMap = {


    // FIXME explode this into modules see https://stackoverflow.com/questions/61013529/how-to-configure-ngrx-data-for-aot-compilation

    // Common
    LovValue: {
        selectId: (lovValue: LovValue) => lovValue.summary.id,
        additionalCollectionState: {
            pages: {}
        }
    },
    LovList: {
        selectId: (lovList: LovListModel) => lovList.summary.id,
        additionalCollectionState: {
            pages: {}
        }
    },
    EntityLog: {
        selectId: (entity: EntityLogModel) => entity.id,
        additionalCollectionState: {
            pages: {}
        }
    },

    Country: {
        selectId: (entity: CountryModel) => entity.value,
        additionalCollectionState: {
            pages: {}
        }
    },

    Person: {
        selectId: (person: PersonModel) => person.summary.id,
        additionalCollectionState: {
            pages: {}
        }
    },
    Statistic: {
        selectId: (entity: StatisticModel) => entity.id,
        additionalCollectionState: {
            pages: {}
        }
    },

    PageViewed: {
        selectId: (entity: PageViewedModel) => entity.id,
        additionalCollectionState: {
            pages: {}
        }
    },
    AudioRecord: {
        selectId: (entity: AudioRecordModel) => entity.summary.id,
        additionalCollectionState: {
            pages: {}
        }
    },
    AudioTranscription: {
        selectId: (entity: AudioTranscriptionModel) => entity.id,
        additionalCollectionState: {
            pages: {}
        }
    },
    BusinessDataImportProcess: {
        selectId: (entity: BusinessDataImportProcessModel) => entity.summary.id,
        additionalCollectionState: {
            pages: {}
        }
    },

    FormDefinitionForm: {
        selectId: (entity: FormDefinitionFormModel) => entity.summary.id,
        additionalCollectionState: {
            pages: {}
        }
    },
    FormDefinitionField: {
        selectId: (entity: FormDefinitionFieldModel) => entity.summary.id,
        additionalCollectionState: {
            pages: {}
        }
    },
    GoalDefinition: {
        selectId: (entity: GoalDefinitionModel) => entity.summary.id,
        additionalCollectionState: {
            pages: {}
        }
    },
    Goal: {
        selectId: (entity: GoalModel) => entity.summary.id,
        additionalCollectionState: {
            pages: {}
        }
    },
    NotificationDefinition: {
        selectId: (entity: NotificationDefinitionModel) => entity.summary.id,
        additionalCollectionState: {
            pages: {}
        }
    },
    NotificationDefinitionGroup: {
        selectId: (entity: NotificationDefinitionGroupModel) => entity.summary.id,
        additionalCollectionState: {
            pages: {}
        }
    },
    NotificationSetting: {
        selectId: (entity: NotificationSettingModel) => entity.id,
        additionalCollectionState: {
            pages: {}
        }
    },
    Notification: {
        selectId: (entity: NotificationModel) => entity.summary.id,
        additionalCollectionState: {
            pages: {}
        }
    },
    Tag: {
        selectId: (entity: TagModel) => entity.summary.id,
        additionalCollectionState: {
            pages: {}
        }
    },

    AiDiscussion: {
        selectId: (entity: AiDiscussionModel) => entity.summary.id,
        additionalCollectionState: {
            pages: {}
        }
    },


    // Insole
    Scanner3d: {
        selectId: (entity: Scanner3dModel) => entity.id,
        additionalCollectionState: {
            pages: {}
        }
    },
    Scanner3dAccount: {
        selectId: (entity: Scanner3dAccountModel) => entity.id,
        additionalCollectionState: {
            pages: {}
        }
    },
    Scan3dGroup: {
        selectId: (entity: Scan3dGroupModel) => entity.summary.id,
        additionalCollectionState: {
            pages: {}
        }
    },
    Scan3d: {
        selectId: (entity: Scan3dModel) => entity.id,
        additionalCollectionState: {
            pages: {}
        }
    },
    Insoles: {
        selectId: (entity: InsolesModel) => entity.summary.id,
        additionalCollectionState: {
            pages: {}
        }
    },
    InsolesModel: {
        selectId: (entity: InsolesModelModel) => entity.summary.id,
        additionalCollectionState: {
            pages: {}
        }
    },
    InsoleMaterial: {
        selectId: (entity: InsoleMaterialModel) => entity.summary.id,
        additionalCollectionState: {
            pages: {}
        }
    },
    InsolesProfile: {
        selectId: (entity: InsolesProfileModel) => entity.summary.id,
        additionalCollectionState: {
            pages: {}
        }
    },
    InsoleCadProcess: {
        selectId: (entity: InsoleCadProcessModel) => entity.summary.id,
        additionalCollectionState: {
            pages: {}
        }
    },
    InsolesProviderModel: {
        selectId: (entity: InsolesProviderModelModel) => entity.summary.id,
        additionalCollectionState: {
            pages: {}
        }
    },
    InsoleElementDefinition: {
        selectId: (entity: InsoleElementDefinitionModel) => entity.summary.id,
        additionalCollectionState: {
            pages: {}
        }
    },
    ProviderCamMachine: {
        selectId: (entity: ProviderCamMachineModel) => entity.summary.id,
        additionalCollectionState: {
            pages: {}
        }
    },
    CamJob: {
        selectId: (entity: CamJobModel) => entity.summary.id,
        additionalCollectionState: {
            pages: {}
        }
    },

    // Online form
    OnlineFormFormDefinition: {
        selectId: (entity: OnlineFormFormDefinitionModel) => entity.summary.id,
        additionalCollectionState: {
            pages: {}
        }
    },

    OnlineFormForm: {
        selectId: (entity: OnlineFormModel) => entity.summary.id,
        additionalCollectionState: {
            pages: {}
        }
    },
    Partner: {
        selectId: (partner: PartnerModel) => partner.summary.id,
        additionalCollectionState: {
            pages: {}
        }
    },
    Note: {
        selectId: (partnerNote: PartnerNote) => partnerNote.id,
        additionalCollectionState: {
            pages: {}
        }
    },
    PartnerPerson: {
        selectId: (partnerPerson: PartnerPersonModel) => partnerPerson.summary.id,
        additionalCollectionState: {
            pages: {}
        }
    },
    PartnerContact: {
        selectId: (partnerContact: PartnerContactModel) => partnerContact.id,
        additionalCollectionState: {
            pages: {}
        }
    },

    Document: {
        selectId: (document: DocumentModel) => document.summary.id,
        additionalCollectionState: {
            pages: {}
        }
    },
    DocumentTemplate: {
        selectId: (document: DocumentTemplateModel) => document.summary.id,
        additionalCollectionState: {
            pages: {}
        }
    },
    Office: {
        selectId: (office: OfficeModel) => office.summary.id,
        additionalCollectionState: {
            pages: {}
        },
        sortComparer: (a: OfficeModel, b: OfficeModel) => a.summary.name.localeCompare(b.summary.name),
    },

    User: {
        selectId: (user: User) => user.summary.id,
        additionalCollectionState: {
            pages: {}
        }
    },

    // Discussion
    Discussion: {
        selectId: (entity: DiscussionModel) => entity.summary.id,
        additionalCollectionState: {
            pages: {}
        }
    },
    Message: {
        selectId: (entity: MessageModel) => entity.summary.id,
        additionalCollectionState: {
            pages: {}
        }
    },


    // Agenda
    AgendaEvent: {
        selectId: (eventModel: AgendaEventModel) => eventModel.summary.id,
        additionalCollectionState: {
            pages: {}
        }
    },
    AgendaCalendar: {
        selectId: (calendar: AgendaCalendarModel) => calendar.summary.id,
        additionalCollectionState: {
            pages: {}
        },
    },
    AgendaCategory: {
        selectId: (entity: AgendaCategory) => entity.summary.id,
        additionalCollectionState: {
            pages: {}
        },
    },
    AgendaPeriod: {
        selectId: (entity: AgendaPeriodModel) => entity.summary.id,
        additionalCollectionState: {
            pages: {}
        },
    },
    AgendaSlot: {
        selectId: (entity: AgendaSlotModel) => entity.summary.id,
        additionalCollectionState: {
            pages: {}
        },
    },
    AgendaReminderConfiguration: {
        selectId: (entity: AgendaReminderConfigurationModel) => entity.id,
        additionalCollectionState: {
            pages: {}
        },
    },
    AgendaBlockedPartner: {
        selectId: (entity: AgendaBlockedPartnerModel) => entity.id,
        additionalCollectionState: {
            pages: {}
        }
    },
    AgendaWaitingList: {
        selectId: (entity: AgendaWaitingListItemModel) => entity.id,
        additionalCollectionState: {
            pages: {}
        }
    },
    AgendaProfile: {
        selectId: (entity: AgendaProfileModel) => entity.id,
        additionalCollectionState: {
            pages: {}
        }
    },

    // Medical
    Practitioner: {
        selectId: (practitioner: Practitioner) => practitioner.summary.id,
        additionalCollectionState: {
            pages: {}
        }
    },

    Consultation: {
        selectId: (entity: ConsultationModel) => entity.summary.id,
        additionalCollectionState: {
            pages: {}
        }
    },

    ConsultationCategory: {
        selectId: (entity: ConsultationCategoryModel) => entity.summary.id,
        additionalCollectionState: {
            pages: {}
        }
    },
    MedicalMorphology: {
        selectId: (entity: MedicalMorphologyModel) => entity.id,
        additionalCollectionState: {
            pages: {}
        }
    },
    MedicalReport: {
        selectId: (entity: MedicalReportModel) => entity.id,
        additionalCollectionState: {
            pages: {}
        }
    },
    MedicalSterilization : {
        selectId: (entity: MedicalSterilizationModel) => entity.summary.id,
        additionalCollectionState: {
            pages: {}
        }
    },
    MedicalToolSet: {
        selectId: (entity: MedicalToolSetModel) => entity.summary.id,
        additionalCollectionState: {
            pages: {}
        }
    },
    // Charged act
    ChargedAct: {
        selectId: (entity: ChargedActModel) => entity.id,
        additionalCollectionState: {
            pages: {}
        }
    },
    MedicalDeviceDefinition : {
        selectId: (entity: DeviceDefinitionModel) => entity.summary.id,
        additionalCollectionState: {
            pages: {}
        }
    },
    MedicalDevice : {
        selectId: (entity: MedicalDeviceModel) => entity.summary.id,
        additionalCollectionState: {
            pages: {}
        }
    },
    MedicalRecordGeneralInformation: {
        selectId: (medicalRecordModel: MedicalRecordGeneralInformationModel) => medicalRecordModel.partner.id,
        additionalCollectionState: {
            pages: {}
        }
    },
    MedicalPractitioner: {
        selectId: (medicalRecordPractitionerModel: MedicalRecordPractitionerModel) => medicalRecordPractitionerModel.id,
        additionalCollectionState: {
            pages: {}
        }
    },
    MedicalSport: {
        selectId: (medicalRecordSportModel: MedicalRecordSportModel) => medicalRecordSportModel.id,
        additionalCollectionState: {
            pages: {}
        }
    },
    MedicalPain: {
        selectId: (medicalRecordPainModel: MedicalRecordPainModel) => medicalRecordPainModel.id,
        additionalCollectionState: {
            pages: {}
        }
    },
    MedicalRecordVisitReason: {
        selectId: (medicalRecordVisitReasonModel: MedicalRecordVisitReasonModel) => medicalRecordVisitReasonModel.id,
        additionalCollectionState: {
            pages: {}
        }
    },
    MedicalProblem: {
        selectId: (medicalRecordProblemModel: MedicalRecordProblemModel) => medicalRecordProblemModel.id,
        additionalCollectionState: {
            pages: {}
        }
    },
    PrescriptionMedicine: {
        selectId: (entity: PrescriptionMedicineModel) => entity.summary.id,
        additionalCollectionState: {
            pages: {}
        }
    },

    Prescription: {
        selectId: (entity: PrescriptionModel) => entity.summary.id,
        additionalCollectionState: {
            pages: {}
        }
    },
    PrescriptionDefinition: {
        selectId: (entity: PrescriptionDefinitionModel) => entity.summary.id,
        additionalCollectionState: {
            pages: {}
        }
    },

    ExamenDefinition: {
        selectId: (entity: ExamenDefinitionModel) => entity.summary.id,
        additionalCollectionState: {
            pages: {}
        }
    },
    ExamForm: {
        selectId: (entity: ExamFormModel) => entity.summary.id,
        additionalCollectionState: {
            pages: {}
        }
    },
    TreatmentDefinition: {
        selectId: (entity: TreatmentDefinitionModel) => entity.summary.id,
        additionalCollectionState: {
            pages: {}
        }
    },
    Treatment: {
        selectId: (entity: TreatmentModel) => entity.summary.id,
        additionalCollectionState: {
            pages: {}
        }
    },

    TreatmentFeedback: {
        selectId: (entity: TreatmentFeedbackModel) => entity.summary.id,
        additionalCollectionState: {
            pages: {}
        }
    },
    TreatmentJourneyDefinition: {
        selectId: (entity: TreatmentJourneyDefinitionModel) => entity.summary.id,
        additionalCollectionState: {
            pages: {}
        }
    },
    TreatmentJourney: {
        selectId: (entity: TreatmentJourneyModel) => entity.summary.id,
        additionalCollectionState: {
            pages: {}
        }
    },

    // Products
    Product: {
        selectId: (productModel: ProductModel) => productModel.summary.id,
        additionalCollectionState: {
            pages: {}
        }
    },
    ProductStockUnit: {
        selectId: (entity: ProductStockUnitModel) => entity.summary.id,
        additionalCollectionState: {
            pages: {}
        }
    },

    WebshopProduct: {
        selectId: (webshopProductModel: WebshopProductModel) => webshopProductModel.summary.id,
        additionalCollectionState: {
            pages: {}
        }
    },

    WebshopCart: {
        selectId: (webshopCartModel: WebshopCartModel) => webshopCartModel.id,
        additionalCollectionState: {
            pages: {}
        }
    },

    WebshopCategory: {
        selectId: (webshopCategoryModel: WebshopCategoryModel) => webshopCategoryModel.summary.id,
        additionalCollectionState: {
            pages: {}
        }
    },

    SaleProduct: {
        selectId: (saleProductModel: SaleProductModel) => saleProductModel.summary.id,
        additionalCollectionState: {
            pages: {}
        }
    },
    ProductDelivered: {
        selectId: (entity: ProductDeliveredModel) => entity.summary.id,
        additionalCollectionState: {
            pages: {}
        }
    },
    ProductRetrocession: {
        selectId: (entity: ProductRetrocessionModel) => entity.id,
        additionalCollectionState: {
            pages: {}
        }
    },

    // Newsletter
    NewsletterPartnerConfig: {
        selectId: (entity: NewsletterPartnerConfigModel) => entity.id,
        additionalCollectionState: {
            pages: {}
        }
    },


    // Sale
    Sale: {
        selectId: (saleModel: SaleModel) => saleModel.summary.id,
        additionalCollectionState: {
            pages: {}
        }
    },
    SaleInvoice: {
        selectId: (saleInvoice: SaleInvoiceModel) => saleInvoice.summary.id,
        additionalCollectionState: {
            pages: {}
        }
    },
    SaleInvoiceConfiguration: {
        selectId: (entity: SaleInvoiceConfigurationModel) => entity.id,
        additionalCollectionState: {
            pages: {}
        }
    },
    SaleRetrocession: {
        selectId: (entity: SaleRetrocessionModel) => entity.summary.id,
        additionalCollectionState: {
            pages: {}
        }
    },
    Parcel: {
        selectId: (entity: ParcelModel) => entity.summary.id,
        additionalCollectionState: {
            pages: {}
        }
    },
    PaymentRequest: {
        selectId: (entity: PaymentRequestModel) => entity.summary.id,
        additionalCollectionState: {
            pages: {}
        }
    },
    PaymentRequestConfiguration: {
        selectId: (entity: PaymentRequestConfigurationModel) => entity.id,
        additionalCollectionState: {
            pages: {}
        }
    },
    PaymentRequestReminder: {
        selectId: (entity: PaymentRequestReminderModel) => entity.summary.id,
        additionalCollectionState: {
            pages: {}
        }
    },
    PaymentRequestMovement: {
        selectId: (entity: PaymentRequestMovementModel) => entity.id,
        additionalCollectionState: {
            pages: {}
        }
    },
    PaymentCardReader: {
        selectId: (entity: PaymentCardReaderModel) => entity.summary.id,
        additionalCollectionState: {
            pages: {}
        }
    },
    PaymentRequestOnlineAttempt: {
        selectId: (entity: PaymentRequestOnlineAttemptModel) => entity.summary.id,
        additionalCollectionState: {
            pages: {}
        }
    },
    PurchaseOrder: {
        selectId: (entity: PurchaseOrderModel) => entity.summary.id,
        additionalCollectionState: {
            pages: {}
        }
    },

    // Communication
    CommunicationContentModel: {
        selectId: (entity: CommunicationContentModelModel) => entity.summary.id,
        additionalCollectionState: {
            pages: {}
        }
    },
    CommunicationReport: {
        selectId: (entity: CommunicationReportModel) => entity.id,
        additionalCollectionState: {
            pages: {}
        }
    },
    CommunicationContentSubstitution: {
        selectId: (entity: CommunicationContentSubstitutionModel) => entity.id,
        additionalCollectionState: {
            pages: {}
        }
    },
    CommunicationConfigurationEmailSender: {
        selectId: (entity: CommunicationConfigurationEmailSenderModel) => entity.summary.id,
        additionalCollectionState: {
            pages: {}
        }
    },
    VisualIdentity: {
        selectId: (entity: VisualIdentityModel) => entity.id,
        additionalCollectionState: {
            pages: {}
        }
    },
    EmailMailbox: {
        selectId: (entity: EmailMailboxModel) => entity.summary.id,
        additionalCollectionState: {
            pages: {}
        }
    },
    EmailTheme: {
        selectId: (entity: EmailThemeModel) => entity.id,
        additionalCollectionState: {
            pages: {}
        }
    },
    EmailThemeDefinition: {
        selectId: (entity: EmailThemeDefinitionModel) => entity.summary.id,
        additionalCollectionState: {
            pages: {}
        }
    },
    ReportTheme: {
        selectId: (entity: ReportThemeModel) => entity.id,
        additionalCollectionState: {
            pages: {}
        }
    },
    ReportThemeDefinition: {
        selectId: (entity: ReportThemeDefinitionModel) => entity.summary.id,
        additionalCollectionState: {
            pages: {}
        }
    },
    WebsiteTheme: {
        selectId: (entity: WebsiteThemeModel) => entity.id,
        additionalCollectionState: {
            pages: {}
        }
    },

    // Reporting
    ReportComponentDefinition: {
        selectId: (entity: ReportComponentDefinitionModel) => entity.id,
        additionalCollectionState: {
            pages: {}
        }
    },
    ReportComponent: {
        selectId: (entity: ReportComponentModel) => entity.summary.id,
        additionalCollectionState: {
            pages: {}
        }
    },
    ReportAccountComponent: {
        selectId: (entity: ReportAccountComponentModel) => entity.id,
        additionalCollectionState: {
            pages: {}
        }
    },
    ReportDefinition: {
        selectId: (entity: ReportDefinitionModel) => entity.summary.id,
        additionalCollectionState: {
            pages: {}
        }
    },

    Subscription: {
        selectId: (entity: SubscriptionModel) => entity.summary.id,
        additionalCollectionState: {
            pages: {}
        }
    },
    PriceList: {
        selectId: (entity: PriceListModel) => entity.summary.id,
        additionalCollectionState: {
            pages: {}
        }
    },
    ProviderService: {
        selectId: (entity: ProviderServiceModel) => entity.summary.id,
        additionalCollectionState: {
            pages: {}
        }
    },
    ProviderServiceOption: {
        selectId: (entity: ProviderServiceOptionModel) => entity.summary.id,
        additionalCollectionState: {
            pages: {}
        }
    },
    Support: {
        selectId: (entity: SupportModel) => entity.id,
        additionalCollectionState: {
            pages: {}
        }
    },

    // Tasks
    WorkflowTask: {
        selectId: (task: WorkflowTaskModel) => task.summary.id,
        additionalCollectionState: {
            pages: {}
        }
    },
    WorkflowTaskDefinition: {
        selectId: (entity: WorkflowTaskDefinitionModel) => entity.id,
        additionalCollectionState: {
            pages: {}
        }
    },
    // Accounting
    BankCheck: {
        selectId: (entity: BankCheckModel) => entity.summary.id,
        additionalCollectionState: {
            pages: {}
        }
    },
    AccountingAccount: {
        selectId: (entity: AccountingAccountModel) => entity.id,
        additionalCollectionState: {
            pages: {}
        }
    },
    AccountingMovement: {
        selectId: (entity: AccountingMovementModel) => entity.summary.id,
        additionalCollectionState: {
            pages: {}
        }
    },
    AccountingOpenBankingRequisition: {
        selectId: (entity: OpenBankingRequisitionModel) => entity.id,
        additionalCollectionState: {
            pages: {}
        }
    },
    AccountingOpenBankingAccount: {
        selectId: (entity: OpenBankingAccountModel) => entity.id,
        additionalCollectionState: {
            pages: {}
        }
    },
    AccountingOpenBankingTransaction: {
        selectId: (entity: OpenBankingTransactionModel) => entity.summary.id,
        additionalCollectionState: {
            pages: {}
        }
    },

    // TimeLog
    TimeLog: {
        selectId: (entity: TimeLogModel) => entity.summary.user.id,
        additionalCollectionState: {
            pages: {}
        }
    },
    // Diagnostic
    Diagnostic: {
        selectId: (entity: DiagnosticModel) => entity.summary.id,
        additionalCollectionState: {
            pages: {}
            }
    },
    // DiagnosticRuleGroup
    DiagnosticRuleGroup: {
        selectId: (entity: DiagnosticRuleGroupModel) => entity.id,
        additionalCollectionState: {
            pages: {}
        }
    },
};
const pluralNames = {
};

export const entityConfig = {
    entityMetadata,
    pluralNames,
};
